import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Student } from '../student.js';

export const getStudentByUserIdQuery = registerQuery({
  operationName: 'getStudentByUserIdQuery',

  type: () => [Student],
  params: [{ name: 'userID', type: () => String }],

  resolve: (userID: string) => async (selection: BaseQLSelectionSet<Student>) => {
    const studentCollection = await getCollection(Student);

    const students = await studentCollection.find({ userID }).toArray();

    const normalizedStudents = students.map((student: any) => ({
      ...student,
      _class: student?._class || 'Student',
    }));

    return normalizedStudents as Student[];
  },
});
